import { createSelector } from 'reselect';
import { RootState } from '../index';
export const getAuthority = (state: RootState) => state.auth;
export const getToken = (state: RootState) => state.auth.user.response?.id;
export const getUser = (state: RootState) => state.auth.user.response?.user;

export const insertGroupStatus = createSelector(
  (state: RootState) => state.activity.insertGroup,
  (insertGroup) => !insertGroup.isFetching && insertGroup.isSuccess
);